import { formatInTimeZone } from "date-fns-tz";

const CURRENCY_SYMBOLS: Record<string, string> = {
  PEN: "S/",
  MXN: "MX$",
  USD: "US$",
  ARS: "AR$",
  COP: "CO$",
  CLP: "CL$",
  EUR: "€",
  BRL: "R$",
};

export function formatMoney(cents: number | null | undefined, currency: string): string {
  if (cents == null) return "-";
  const amount = cents / 100;
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency;
  return `${symbol} ${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatDateTZ(
  iso: string | Date | null | undefined,
  timezone: string,
  pattern: string = "dd MMM yyyy HH:mm"
): string {
  if (!iso) return "-";
  try {
    return formatInTimeZone(iso, timezone, pattern);
  } catch {
    return String(iso);
  }
}

export function formatDateOnlyTZ(
  iso: string | Date | null | undefined,
  timezone: string
): string {
  return formatDateTZ(iso, timezone, "dd MMM yyyy");
}

export function formatCode(code: string): string {
  const clean = code.replace(/-/g, "").toUpperCase();
  if (clean.length !== 8) return clean;
  return `${clean.slice(0, 4)}-${clean.slice(4)}`;
}

const DURATION_LABEL: Record<number, string> = {
  7: "Semanal",
  15: "Quincenal",
  30: "Mensual",
  60: "Bimestral",
  90: "Trimestral",
  120: "Cuatrimestral",
  180: "Semestral",
  360: "Anual",
  365: "Anual",
};

/** Nombre natural de un plan a partir de sus días. */
export function formatDuration(days: number): string {
  if (DURATION_LABEL[days]) return DURATION_LABEL[days];
  if (days === 1) return "1 día";
  if (days % 30 === 0) return `${days / 30} meses`;
  return `${days} días`;
}

const CADENCE_LABEL: Record<number, string> = {
  7: "cada semana",
  15: "cada 15 días",
  30: "cada mes",
  60: "cada 2 meses",
  90: "cada 3 meses",
  120: "cada 4 meses",
  180: "cada 6 meses",
  360: "cada año",
  365: "cada año",
};

/** Cadencia de renovación en lenguaje natural. */
export function formatRenewalCadence(days: number): string {
  if (CADENCE_LABEL[days]) return CADENCE_LABEL[days];
  if (days % 30 === 0) return `cada ${days / 30} meses`;
  return `cada ${days} días`;
}
